<div class="app-bg-mono">
  <div class="vh-109 justify-content-center align-items-center app-bg-mono row">
    <div class="app-main-container">
      <div style="text-align: center">
        <h1>{{ overviewTitle }}</h1>
      </div>
      <div class="app-block-container justify-content-center vw-100 app-grid">
        <div *ngFor="let section of relevantSections; let i = index">
          <app-overview-block
            [part]="i + 1"
            [thumbnail]="thumbnails[i % thumbnails.length]"
            [finished]="section.idx < getTimelineIdx()"
            [name]="section.section"
          >
          </app-overview-block>
        </div>
      </div>
      <div class="my-5 d-flex justify-content-center">
        <app-continue-button
          [label]="continueButtonLabel"
        ></app-continue-button>
      </div>
    </div>
  </div>
</div>
